import { HttpException } from './http.exception';

export class HttpNotFoundException extends HttpException {}
